(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wolds-shop-v2"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-wshop]').forEach(function (shop) {
  var buttons = Array.prototype.slice.call(shop.querySelectorAll('[data-feel-filter]'));
  var cards = Array.prototype.slice.call(shop.querySelectorAll('[data-wshop-card]'));
  var empty = shop.querySelector('[data-wshop-empty]');
  if (!buttons.length || !cards.length) return;

  function applyFilter(value) {
    var visible = 0;
    cards.forEach(function (card) {
      var show = value === 'all' || card.dataset.feel === value;
      card.hidden = !show;
      if (show) visible += 1;
    });
    buttons.forEach(function (button) {
      var active = button.dataset.feelFilter === value;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    if (empty) empty.hidden = visible !== 0;
  }

  buttons.forEach(function (button) {
    button.addEventListener('click', function () {
      applyFilter(button.dataset.feelFilter);
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
